import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { SynchronizationFormComponent } from '../synchronization-form/synchronization-form.component';
import {
  SynchronizationFormConfig,
  SYNCHRONIZATION_HEADER_ACTIONS,
  SYNCHRONIZATION_TABLE_SECTIONS,
  createSynchronizationFormFields,
} from '../../synchronization.config';

@Component({
  selector: 'app-synchronization-add',
  standalone: true,
  imports: [SynchronizationFormComponent],
  templateUrl: './synchronization-add.component.html',
  styleUrls: ['./synchronization-add.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SynchronizationAddComponent implements CanComponentDeactivate {
  @ViewChild('formWrapper') private readonly formWrapper?: SynchronizationFormComponent;

  config: SynchronizationFormConfig = {
    title: 'synchronization.form.add.title',
    formFields: createSynchronizationFormFields(),
    headerActions: SYNCHRONIZATION_HEADER_ACTIONS,
    tableSections: SYNCHRONIZATION_TABLE_SECTIONS,
    listRoute: '/stock/synchronization',
  };

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }
}
